module.exports = __webpack_public_path__ + "media/stylesheets/images/focus_@2X-539957572822075f9794793059d1615c.png";